class InfiniteScroll {
  constructor() {
    // Find the main collection section's product list (not featured collections)
    const collectionSection = document.querySelector('.shopify-section--main-collection');
    if (!collectionSection) return;

    this.container = collectionSection.querySelector('.product-list');
    this.paginationContainer = collectionSection.querySelector('.pagination');
    this.loading = false;
    this.enabled = document.body.dataset.infiniteScroll === 'true';

    if (!this.enabled || !this.container || !this.paginationContainer) return;

    this.nextLink = this.paginationContainer.querySelector('[rel="next"]');
    if (!this.nextLink) return;

    this.init();
  }

  init() {
    // Hide pagination on load
    this.paginationContainer.style.display = 'none';

    // Create loading indicator
    this.loadingIndicator = this.createLoadingIndicator();
    this.container.parentElement.appendChild(this.loadingIndicator);

    // Set up intersection observer
    this.observer = new IntersectionObserver(
      (entries) => this.handleIntersection(entries),
      { rootMargin: '400px' }
    );

    this.observer.observe(this.loadingIndicator);
  }

  createLoadingIndicator() {
    const indicator = document.createElement('div');
    indicator.className = 'infinite-scroll-loader';
    indicator.innerHTML = `
      <div class="infinite-scroll-spinner">
        <svg width="40" height="40" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
          <circle cx="20" cy="20" r="18" fill="none" stroke="currentColor" stroke-width="3" stroke-dasharray="90, 150" stroke-linecap="round">
            <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1.5s" values="0 20 20;360 20 20" keyTimes="0;1"/>
          </circle>
        </svg>
      </div>
    `;
    indicator.style.cssText = 'text-align: center; padding: 2rem; opacity: 0;';
    return indicator;
  }

  async handleIntersection(entries) {
    const entry = entries[0];

    if (entry.isIntersecting && !this.loading && this.nextLink) {
      await this.loadMore();
    }
  }

  async loadMore() {
    if (this.loading || !this.nextLink) return;

    this.loading = true;
    this.loadingIndicator.style.opacity = '1';

    try {
      const response = await fetch(this.nextLink.href);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Get new products from ONLY the main collection section
      const newCollectionSection = doc.querySelector('.shopify-section--main-collection');
      if (!newCollectionSection) return;

      const newProductList = newCollectionSection.querySelector('.product-list');
      if (!newProductList) return;

      const newProducts = newProductList.querySelectorAll('.product-card');

      if (newProducts.length > 0) {
        newProducts.forEach(product => {
          this.container.appendChild(product);
        });
      }

      // Update next link from main collection section only
      const newPagination = newCollectionSection.querySelector('.pagination');
      const newNextLink = newPagination?.querySelector('[rel="next"]');

      if (newNextLink) {
        this.nextLink = newNextLink;
      } else {
        // No more pages
        this.nextLink = null;
        this.observer.disconnect();
        this.loadingIndicator.style.display = 'none';
      }

    } catch (error) {
      console.error('Infinite scroll error:', error);
    } finally {
      this.loading = false;
      this.loadingIndicator.style.opacity = '0';
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new InfiniteScroll());
} else {
  new InfiniteScroll();
}
